import config from '../config.mjs';
import {Loader as MapLoader} from '@googlemaps/js-api-loader';

export default (new MapLoader({
  apiKey: config.googleMapsApiKey,
  version: 'weekly',
  libraries: [
    'places'
  ],
  fields: [
    'formatted_address',
    'geometry',
  ],
}));
